import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TournamentHeader = ({ tournament, isParticipating, onJoinLeave, onViewPredictions }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const getDaysUntilStart = () => {
    const today = new Date();
    const startDate = new Date(tournament.startDate);
    const diffTime = startDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const daysUntilStart = getDaysUntilStart();

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden mb-6">
      <div className="relative h-48 md:h-64 lg:h-80 overflow-hidden">
        <Image
          src={tournament?.bannerImage}
          alt={tournament?.bannerImageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 lg:p-8">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-3 py-1 bg-primary text-primary-foreground text-xs md:text-sm font-semibold rounded-full">
              {tournament?.format}
            </span>
            {tournament?.status === 'upcoming' && (
              <span className="px-3 py-1 bg-accent text-accent-foreground text-xs md:text-sm font-semibold rounded-full">
                Upcoming
              </span>
            )}
          </div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2">
            {tournament?.name}
          </h1>
          <div className="flex flex-wrap items-center gap-4 text-white/90 text-sm md:text-base">
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={18} />
              <span>{formatDate(tournament?.startDate)} - {formatDate(tournament?.endDate)}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={18} />
              <span>{tournament?.location}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Users" size={18} />
              <span>{tournament?.participants} Participants</span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 lg:p-8 bg-muted/50">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 flex-1">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Trophy" size={24} color="var(--color-primary)" />
              </div>
              <div>
                <p className="text-xs md:text-sm text-muted-foreground">1st Prize</p>
                <p className="text-sm md:text-base font-bold text-foreground">{tournament?.prize1 || 'TBA'}</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                <Icon name="Award" size={24} color="var(--color-accent)" />
              </div>
              <div>
                <p className="text-xs md:text-sm text-muted-foreground">2nd Prize</p>
                <p className="text-sm md:text-base font-bold text-foreground">{tournament?.prize2 || 'TBA'}</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center">
                <Icon name="Medal" size={24} color="var(--color-success)" />
              </div>
              <div>
                <p className="text-xs md:text-sm text-muted-foreground">3rd Prize</p>
                <p className="text-sm md:text-base font-bold text-foreground">{tournament?.prize3 || 'TBA'}</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            {isParticipating ? (
              <>
                <Button
                  variant="default"
                  iconName="Target"
                  iconPosition="left"
                  onClick={onViewPredictions}
                  className="w-full sm:w-auto"
                >
                  View My Predictions
                </Button>
              </>
            ) : (
              <Button
                variant="default"
                iconName="UserPlus"
                iconPosition="left"
                onClick={() => onJoinLeave(true)}
                className="w-full sm:w-auto"
              >
                Join Tournament
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentHeader;